import { DateTime } from 'luxon';

export type ShiftMultiplyCalendarProps = {
  shiftDate: DateTime;
  onChange(dates: DateTime[]): void;
};

export const CALENDAR_MONTHS_AVAILABLE_FOR_PLANNING = 4;
